import { jsx } from "react/jsx-runtime";
import { isEditor } from "../../utils/isEditor.esm.js";
import RefinanceCalculator from "./RefinanceCalculator.esm.js";
import { FieldConfig } from "./RefinanceCalculator.utils.esm.js";
const RefinanceCalculatorBlock = {
  Component: ({
    attrs
  }) => {
    const {
      loanAmount,
      rate,
      term,
      originationYear,
      newLoanAmount,
      newTerm,
      newRate,
      fees,
      cashOut,
      rollFees
    } = attrs;
    const defaultValues = {
      loanAmount,
      rate,
      term,
      originationYear,
      newLoanAmount,
      newTerm,
      newRate,
      fees,
      cashOut,
      rollFees
    };
    return /* @__PURE__ */ jsx(RefinanceCalculator, { ...{
      defaultValues
    } }, isEditor() ? JSON.stringify(defaultValues) : void 0);
  },
  metadata: {
    version: "1.0",
    name: "constellation/refinance-calculator",
    title: "Refinance calculator",
    description: "Find out if refinancing makes sense for you.",
    icon: "index-card",
    keywords: ["mortgages", "calculators", "refinance"],
    category: "Calculators",
    supports: {
      customClassName: false,
      html: false
    },
    attributes: {
      [FieldConfig.loanAmount.name]: {
        type: "number",
        default: 2e5,
        label: "Default loan amount",
        control: "number"
      },
      rate: {
        type: "number",
        default: 5,
        label: "Default rate",
        control: "number"
      },
      term: {
        type: "number",
        default: 360,
        label: "Default term",
        control: "number"
      },
      newLoanAmount: {
        type: "number",
        default: 195e3,
        label: "Default new loan amount",
        control: "number"
      },
      newTerm: {
        type: "number",
        default: 360,
        label: "Default new term",
        control: "number"
      },
      newRate: {
        type: "number",
        default: 4.35,
        label: "Default new rate",
        control: "number"
      },
      fees: {
        type: "number",
        default: 1e3,
        label: "Default fees",
        control: "number"
      },
      cashOut: {
        type: "number",
        default: 0,
        label: "Default cash out",
        control: "number"
      }
    }
  }
};
export {
  RefinanceCalculatorBlock as default
};
